module.exports = __webpack_public_path__ + "static/media/24WingChunAcademyLR-132.404935e1.jpg";